import { hotjar } from 'react-hotjar';

import { Wrapper } from '@american-autonomy/rantizo-ui';

import useAccount from 'hooks/useAccount';
import useCurrentOrganization from 'hooks/useCurrentOrganization';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const HotJar: FunctionComponent<Props> = ({ children, testId = TEST_ID }) => {
    const { user } = useAccount();

    const { currentOrganization } = useCurrentOrganization();

    hotjar.initialize({
        id: Number(import.meta.env.VITE_HOT_JAR_ID),
        sv: 6
    });

    if (user && currentOrganization) {
        hotjar.identify(user?.id, {
            email: user?.email,
            organizationId: currentOrganization?.id
        });
    }

    return <Wrapper testId={testId}>{children}</Wrapper>;
};

export default HotJar;
